import type { IJob } from '@quesmed/types/models';
import { BsImage } from 'react-icons/bs';
import { FaRegFileAlt } from 'react-icons/fa';
import { IoMdAlert } from 'react-icons/io';

export const JobSummary = ({
  resolvedCount,
  remarkCount,
  // memberCount,
  totalRecords,
  recordCount,
  publishedCount,
  assetCount,
}: {
  chatCount: IJob['chatCount'];
  resolvedCount: IJob['resolvedCount'];
  remarkCount: IJob['remarkCount'];
  memberCount: IJob['memberCount'];
  totalRecords: IJob['totalRecords'];
  recordCount: IJob['recordCount'];
  publishedCount: IJob['publishedCount'];
  assetCount: IJob['assetCount'];
}) => {
  return (
    <div className='flex items-center gap-1'>
      {/* <div
        title='Comments'
        className='flex items-center gap-1 border border-default-300 rounded-lg px-1.5 py-0.5'
      >
        <span className='text-xs text-default-500'>{chatCount}</span>
        <FaComments className='size-3 text-cyan-500' />
      </div> */}

      {/* <div
        title='Members'
        className='flex items-center gap-1 border border-default-300 rounded-lg px-1.5 py-0.5'
      >
        <span className='text-xs text-default-500'>{memberCount}</span>
        <IoPeopleSharp className='size-3 text-warning-500' />
      </div> */}
      <div
        title='Published/Completed/Total Records'
        className='flex items-center gap-1 border border-default-300 rounded-lg px-1.5 py-0.5'
      >
        <span className='text-xs flex items-center gap-1 text-default-500'>
          <span className='text-default-500'>{publishedCount}</span> |{' '}
          <span className='text-default-500'>{recordCount}</span> |{' '}
          <span className='text-default-500'>{totalRecords}</span>
        </span>
        <FaRegFileAlt className='size-3 text-warning-500' />
      </div>
      {!!remarkCount && (
        <div
          title='Resolved/TotalRemarks'
          className='flex items-center gap-1 border border-default-300 rounded-lg px-1.5 py-0.5'
        >
          <span className='text-xs flex items-center gap-1 text-default-500'>
            <span className='text-default-500'>{resolvedCount}</span> |{' '}
            <span className='text-default-500'>{remarkCount}</span>{' '}
          </span>
          <IoMdAlert className='size-3 text-danger-500' />
        </div>
      )}
      {!!assetCount && (
        <div
          title='Assets'
          className='flex items-center gap-1 border border-default-300 rounded-lg px-1.5 py-0.5'
        >
          <span className='text-xs flex items-center gap-1 text-default-500'>
            <span className='text-default-500'>{assetCount}</span>
          </span>
          <BsImage className='size-3 text-success-500' />
        </div>
      )}
    </div>
  );
};
